import { useEffect , useState} from "react";
import ExamsStyle from "../styles&pics/ExamsStyle";
import ExamsQSelection from "./ExamsQSelection";
import { Link } from 'react-router-dom';



const Exams = () => {
 let [storedUser, setStoredUser] = useState('');

  useEffect(() => {
     storedUser = localStorage.getItem('loggedInUser');
     setStoredUser(storedUser);
  }, []);
  
  
  return (
    <>
      <ExamsStyle />
      <main className="exams-main">
        <div className="exams-container">
          <div className="exams-card">
            <div className="exams-header">
              <h1 className="exams-title">Προσομοίωση Εξετάσεων</h1>
            </div>

            <div className="exams-content">
              <p className="exams-text">
                Καλωσήρθες στην προσομοίωση των εξετάσεων πιστοπoίησης, εδώ θα εξεταστείς σε τυχαίες ερωτήσεις πιστοποίησης του ΕΟΠΠΕΠ
                με μέγιστη διάρκεια τις 3 ώρες όπου και η εφαρμογή θα προχωρήσει αυτόματα στην διόρθωση όσων ερωτήσεων έχεις απαντήσει
                ως εκείνη την χρονική στιγμή.
              </p>

              <div className="exams-greeting">
                <h2>Καλή επιτυχία {storedUser ? storedUser : "επισκέπτη"}!</h2>
              </div>

              <div className="button-container">
                <Link to="/examsform" className="button">
                  Έναρξη εξετάσεων
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Exams;